




































import { IUser } from "@/@types/admin/user/user";
import { auth, excursions, order } from "@/config/host.config";
import { AccessToken } from "@/services/accessDecoder";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { orders as orderConfig } from "@/config/tab-nav/orders/order-servers.json";
import { IOrder } from "@/@types/orders/new-order";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { ICategory, IProductCard } from "@/@types/menu/menu/menu";
import { IReason } from "@/@types/orders/reason";
import { AxiosResponse } from "axios";

import OrderList from "@/components/orders/bars/order-list.vue";
import OrderConstructopr from "@/components/orders/bars/order-constructopr.vue";

@Component({ components: { OrderList, OrderConstructopr } })
export default class ExcursionOrders extends Vue {
  @Prop({ type: Array, default: () => [] }) vrooms!: Array<IVirtualRooma>;
  @Prop({ type: Array, default: () => [] }) routes!: Array<string>;
  @Prop({ type: String, default: "" }) route!: string;

  manager_id = "";
  order_id = "";
  bar_id = "";
  status = "";
  master = AccessToken.id;
  new_order = false;

  orderInterval!: ReturnType<typeof setInterval> | undefined;

  excursions: Array<IProductCard> = [];
  categorys: Array<ICategory> = [];
  managers: Array<IUser> = [];
  orderList: Array<IOrder> = [];
  reasons: Array<IReason> = [];

  get manager(): IUser | null {
    const waiter = this.managers.find((w) => w._id === this.manager_id);
    return waiter ? waiter : null;
  }

  get order(): IOrder | null {
    const order = this.orderList.find((b) => b._id === this.order_id);
    return order ? order : null;
  }

  get orders(): Array<IOrder> {
    if (!this.bar_id) return this.orderList;
    return this.orderList.filter((order) => {
      const shop = order.cart.find((el) => el.shop_id == this.bar_id);
      if (shop) return order;
    });
  }

  newOrder(): void {
    this.new_order = true;
  }

  orderOpen(id: string): void {
    this.new_order = true;
    this.order_id = id;
    this.$nextTick(() => {
      if (this.order?.status == "new") this.changeStatus({ status: "active" });
    });
  }

  @Watch("order_id")
  updateGetOrders(): void {
    if (!this.order_id)
      this.orderInterval = setInterval(() => this.getOrders(), this.$second(5));
    else clearInterval(this.orderInterval);
  }

  async getPadawans(): Promise<void> {
    if (!this.master) return;
    const url = auth.getUser;
    const params = { master: this.master };
    try {
      const resUser = await this.$axios.get(url, { params });
      if (resUser.status === 200) this.managers = resUser.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getOrders(): Promise<void> {
    const url = order.mainAPI;
    const params = {
      "match[show]": true,
      "match[server_name]": orderConfig[1].server,
    };
    try {
      const resOrders: AxiosResponse<IOrder[]> = await this.$axios.get(url, {
        params,
      });
      if (resOrders.status === 200) this.orderList = resOrders.data.reverse();
    } catch (error) {
      console.log(error);
    }
  }

  async getMenu(): Promise<void> {
    const url = excursions.mainAPI;
    const params = {
      "match[deleted][value]": false,
      "match[show]": true,
    };
    try {
      const resproduct = await this.$axios.get(url, { params });
      if (resproduct.status === 200) this.excursions = resproduct.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getCategorys(): Promise<void> {
    const url = excursions.category;
    const params = {
      "match[deleted][value]": false,
      "match[show]": true,
    };
    try {
      const resproduct = await this.$axios.get(url, { params });
      if (resproduct.status === 200) this.categorys = resproduct.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getReason(): Promise<void> {
    const url = order.reason;
    const params = {
      "match[deleted][value]": false,
      "match[show]": true,
    };
    try {
      const resproduct = await this.$axios.get(url, { params });
      if (resproduct.status === 200) this.reasons = resproduct.data;
    } catch (error) {
      console.log(error);
    }
  }

  async changeStatus(data: Partial<IOrder>): Promise<void> {
    if (!this.order) return;
    try {
      const uri = order.mainAPI + "/" + this.order._id;
      const res = await this.$axios.put(uri, data);
      if (res.status === 200) {
        this.onSuccess();
        const i = this.orderList.findIndex((el) => el._id == this.order?._id);
        if (i < 0) return this.getOrders();
        this.$set(this.orderList[i], "status", data.status);
      }
    } catch (error) {
      this.onError();
    }
  }

  async changeOrder(data: Partial<IOrder>): Promise<void> {
    if (!this.order) return;
    try {
      const uri = order.mainAPI + "/change/" + this.order._id;
      const res = await this.$axios.put(uri, data);
      if (res.status === 200) {
        this.onSuccess();
        const i = this.orderList.findIndex((el) => el._id == this.order?._id);
        if (i < 0) return this.getOrders();
        this.$set(this.orderList, i, res.data);
      }
    } catch (error) {
      this.onError();
    }
  }

  onSuccess(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("error.200")),
    });
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  mounted(): void {
    this.getPadawans();
    this.getOrders();
    this.getMenu();
    this.getCategorys();
    this.getReason();
    const order_show_new = sessionStorage.getItem("order_show_new");
    this.status = order_show_new ? order_show_new : "";

    this.orderInterval = setInterval(() => this.getOrders(), this.$second(5));

    const bar = localStorage.getItem("my-order-bar");
    this.bar_id = bar ? bar : "";
  }

  beforeDestroy(): void {
    clearInterval(this.orderInterval);
  }
}
